import "./bootstrap";

import Vue from 'vue'
import Root from './views/root.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(Root)
}).$mount('#app')